import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import Forms from '../common/forms';

export default class Newsletter {
    constructor() {
        this.section = document.querySelector('.component-newsletter');
        this.form = this.section.querySelector('#formNewsletter');
        this.formFields = this.form.querySelectorAll('input, select, textarea');
        this.successMessage = this.section.querySelector('.callbackNews');
        this.errorMessage = this.section.querySelector('.error-form');
        this.btnSubmit = this.form.querySelector('button');

        this.ready();
        this.initRecaptcha();

        new Forms();
    }

    ready() {
        new Bouncer(`#formNewsletter`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });

        this.form.addEventListener(
            'bouncerFormInvalid',
            () => {
                Forms.activeErros(this.form);
            },
            false
        );

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendForm(event.target);
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formFields.forEach((field) => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            });
        });
    }

    sendForm(form) {
        reloadCaptcha('newsletter', 'g-recaptcha-response', () => {
            if (this.errorMessage) {
                this.errorMessage.classList.add('hidden');
            }
            this.successMessage.classList.add('hidden');

            Forms.setLoading(this.btnSubmit, true);

            const dataForm = new FormData(form);

            if (this.form.querySelector('#aceite').checked) {
                dataForm.set('aceite', 1);
            } else {
                dataForm.set('aceite', 0);
            }

            axios({
                method: 'POST',
                url: base_url + 'storeNewsletter',
                data: dataForm,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(() => {
                    form.reset();
                    this.form.classList.add('hidden');
                    Forms.showSuccess(form, this.successMessage, this.errorMessage || { classList: { add: () => {} } });
                    Forms.setLoading(this.btnSubmit, false);
                })
                .catch(() => {
                    console.error('Erro ao enviar o formulário');
                    if (this.errorMessage) {
                        Forms.showError(this.errorMessage, this.successMessage);
                    }
                    Forms.setLoading(this.btnSubmit, false);
                });
        });
    }
}
if (document.querySelector('.component-newsletter')) {
    new Newsletter();
}
